import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDatabaseCertificationParams {
  id: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetDatabaseCertificationRequest extends Request<IDatabaseCertificationParams, IResult> {
  constructor(params: IDatabaseCertificationParams) {
    super('setDatabaseCertification', params);
  }
}
